import { useContext } from 'react'

import { LocalisationContext } from 'providers/localisation/LocalisationContext'

export const useLocale = () => useContext(LocalisationContext)
